var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 15,
    viewBox: "0 0 42 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 11.3599,
    rx: 2,
    fill: "#FFAA00",
    style: {
      fill: "#FFAA00",
      fill: "color(display-p3 1.0000 0.6667 0.0000)",
      fillOpacity: 1
    }
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 3,
    y: 8.5,
    fontFamily: "Arial",
    fontSize: 8,
    fontWeight: "bold",
    fill: "black"
  }, "PREVIEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.195e913345029746b59184a92ae98fe6.svg";
export { ForwardRef as ReactComponent };